import log from "@/lib/calendesk-js-library/tools/log";
import store from "@/store/index";
import { pluralFormIndex } from "@/lib/calendesk-js-library/tools/pluralFormIndex";
import { fillInvoicingBrand } from "@/lib/calendesk-js-library/tools/invoicingBrand";

export const trans = (key, attributes) => {
  const translations = { ...store.state.setup.translations };

  let trans = translations[key];

  if (trans) {
    if (attributes) {
      Object.keys(attributes).forEach((value) => {
        trans = trans.replace(`@{${value}}`, attributes[value]);
      });
    }

    return fillInvoicingBrand(trans);
  }

  log.warn("Translation missing!", key);
  return key;
};

export const transPlural = (key, count, attributes) => {
  const translations = { ...store.state.setup.translations };

  let value = translations[key];

  if (value) {
    const forms = value.split("|");
    let selected = (
      forms[
        pluralFormIndex(
          count,
          forms.length,
          document.documentElement.lang || "en",
        )
      ] || forms[0]
    ).trim();

    if (attributes) {
      Object.keys(attributes).forEach((attr) => {
        selected = selected.replace(`@{${attr}}`, attributes[attr]);
      });
    }

    return fillInvoicingBrand(selected);
  }

  log.warn("Translation missing!", key);
  return key;
};
